import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M8.669 8.471v-3.69h.272a.561.561 0 0 0 .559-.564V3.83a.562.562 0 0 0-.56-.565H7.593v-1.95a.562.562 0 0 0-.56-.565h-.379a.562.562 0 0 0-.559.565v1.951H3.89V1.315A.562.562 0 0 0 3.33.75h-.38a.562.562 0 0 0-.559.565v1.951H1.06a.562.562 0 0 0-.559.565v.386c0 .308.246.565.56.565h.271v3.695c0 1.345.972 2.465 2.248 2.662v.128c0 .209.167.387.384.387h.328v1.031c0 .308.245.565.559.565h.379a.562.562 0 0 0 .559-.565v-1.031h.28a.386.386 0 0 0 .385-.387v-.135c1.26-.212 2.216-1.325 2.216-2.66Z" fill="#000" stroke="#fff" stroke-width=".5"/>' }
  })
);